import React from 'react';
import { getEduPlusBuyLink } from '../../../utils/interriskLink';

// Tabela świadczeń wg programu DATUS 2026/2027 (InterRisk EDU Plus).
// Używana na stronach /edu (Dziecko).
// Pogrubienia i wyróżnienia 1:1 z materiału źródłowego (PROGRAM DATUS.docx).

export const BUY_LINK = getEduPlusBuyLink();
export const CLIENT_ID = '5jad3';

const programCodes = ['6T96JWZL', 'NJTOWZNO', '28BXH4LD', 'OKNPUANW'];

const sumyUbezpieczenia = ['35 000 zł', '48 000 zł', '60 000 zł', '100 000 zł'];

const skladkiRoczne = ['73,00 zł', '101,00 zł', '133,00 zł', '207,00 zł'];

// values - 4 kwoty (Wariant I-IV), value - jedna wartość wspólna dla wszystkich wariantów.
// Wartości tekstowe (poza "brak") są renderowane pogrubione, jak w materiale źródłowym.
const swiadczenia = [
  {
    label:
      'Śmierć Ubezpieczonego na terenie placówki oświatowej w wyniku NW',
    values: ['140 000 zł', '192 000 zł', '240 000 zł', '400 000 zł']
  },
  {
    label: 'Śmierć Ubezpieczonego w następstwie wypadku komunikacyjnego',
    values: ['45 000 zł', '60 000 zł', '100 000 zł', '160 000 zł']
  },
  {
    label:
      'Śmierć Ubezpieczonego w wyniku NW (w tym również zawał serca i udar mózgu u dziecka)',
    values: ['35 000 zł', '48 000 zł', '60 000 zł', '100 000 zł']
  },
  {
    label: 'Uszczerbek od 1% do 25% - wypłata 1% SU za 1% uszczerbku',
    values: ['350 zł', '480 zł', '600 zł', '1 000 zł']
  },
  {
    label: (
      <>
        <b>Uszczerbek powyżej 25% - wypłata 2% SU za każdy 1% uszczerbku</b>{' '}
        (uszczerbek ustalany na podstawie tabeli norm z Załącznika nr 3 OWU EDU
        Plus)
      </>
    ),
    values: ['700 zł', '960 zł', '1 200 zł', '2 000 zł']
  },
  {
    label: (
      <>
        <b>Pobicie, napaść</b> - uszczerbek powyżej 20%, wypłata 1,5% SU za
        każdy 1% uszczerbku
      </>
    ),
    values: ['525 zł', '720 zł', '900 zł', '1 500 zł']
  },
  {
    label: (
      <>
        <b>Koszty porady psychologa</b> w związku z NW lub poważną chorobą
        Ubezpieczonego, śmiercią rodzica lub opiekuna prawnego w wyniku NW
      </>
    ),
    values: ['500 zł', '500 zł', '500 zł', '500 zł']
  },
  {
    label: (
      <>
        <b>Koszty nabycia wyrobów medycznych</b> wydawanych na zlecenie (np.
        stabilizatora, kołnierza ortopedycznego) oraz koszty zakupu lub naprawy
        okularów korekcyjnych lub aparatu słuchowego lub aparatu
        ortodontycznego lub pompy insulinowej uszkodzonych w wyniku NW na
        terenie placówki oświatowej (do 300 zł)
      </>
    ),
    values: ['do 10 500 zł', 'do 14 400 zł', 'do 18 000 zł', 'do 30 000 zł']
  },
  {
    label: (
      <>
        <b>Koszty podróży marzeń</b> - pokrycie poniesionych kosztów przez
        rodzica lub opiekuna prawnego w związku z organizacją dla
        niepełnosprawnego dziecka podróży marzeń lub prywatnego spotkania z
        ulubioną gwiazdą sportu, literatury, polityki lub rozrywki
      </>
    ),
    values: ['do 10 500 zł', 'do 14 400 zł', 'do 18 000 zł', 'do 30 000 zł']
  },
  {
    label: (
      <>
        Uszczerbek na zdrowiu w wyniku ataku <b>padaczki</b>
      </>
    ),
    values: ['350 zł', '480 zł', '600 zł', '1 000 zł']
  },
  {
    label: (
      <>
        Rozpoznanie <b>sepsy</b> u Ubezpieczonego będącego dzieckiem
      </>
    ),
    values: ['3 500 zł', '4 800 zł', '5 000 zł', '5 000 zł']
  },
  {
    label: 'Śmierć opiekuna prawnego lub rodzica Ubezpieczonego w wyniku NW',
    values: ['3 500 zł', '4 800 zł', '6 000 zł', '10 000 zł']
  },
  {
    label: 'Pogryzienie przez psa - bez wymogu pobytu w szpitalu',
    values: ['350 zł', '480 zł', '600 zł', '1 000 zł']
  },
  {
    label: 'Pokąsania, ukąszenia - wymóg pobytu w szpitalu 2 dni',
    values: ['700 zł', '960 zł', '1 200 zł', '2 000 zł']
  },
  {
    label:
      'Zatrucie pokarmowe, nagłe zatrucie gazami bądź porażenie prądem lub piorunem - wymóg pobytu w szpitalu 3 dni',
    values: ['700 zł', '960 zł', '1 200 zł', '2 000 zł']
  },
  {
    label:
      'Rozpoznanie u Ubezpieczonego chorób odzwierzęcych (bąblowicy, toksoplazmozy, wścieklizny)',
    values: ['1 750 zł', '2 400 zł', '3 000 zł', '5 000 zł']
  },
  {
    label: <b>Koszty akcji poszukiwawczej dziecka</b>,
    values: ['do 3 500 zł', 'do 4 800 zł', 'do 6 000 zł', 'do 10 000 zł']
  },
  {
    label: (
      <>
        <b>Oparzenia i odmrożenia</b> (II stopień - 10% SU; III stopień - 30%
        SU; IV stopień - 50% SU)
      </>
    ),
    values: ['do 2 500 zł', 'do 3 500 zł', 'do 4 000 zł', 'do 5 000 zł']
  },
  {
    label: (
      <>
        <b>Pobyt w szpitalu w wyniku NW</b> - świadczenie od <b>pierwszego</b>{' '}
        dnia pobytu, pod warunkiem pobytu w szpitalu trwającego min. 2 dni;
        zgodnie z OWU
      </>
    ),
    values: ['70 zł / dzień', '80 zł / dzień', '90 zł / dzień', '100 zł / dzień']
  },
  {
    label: (
      <>
        <b>Pobyt w szpitalu w wyniku choroby</b> - świadczenie od{' '}
        <b>drugiego</b> dnia pobytu, pod warunkiem pobytu w szpitalu trwającego
        min. 3 dni; zgodnie z OWU
      </>
    ),
    values: ['60 zł / dzień', '80 zł / dzień', '90 zł / dzień', '100 zł / dzień']
  },
  {
    label: (
      <>
        <b>Poważne choroby</b> (nowotwór złośliwy, paraliż, niewydolność nerek,
        poliomyelitis, utrata wzroku, utrata mowy, utrata słuchu, anemia
        aplastyczna, stwardnienie rozsiane, cukrzyca typu I, niewydolność
        serca, <b>wada wrodzona serca</b>, zapalenie opon mózgowo-rdzeniowych,
        transplantacja głównych organów)
      </>
    ),
    values: ['1 200 zł', '2 000 zł', '2 000 zł', '2 000 zł']
  },
  {
    label: 'Operacje w wyniku NW - wg tab. nr 7 OWU',
    values: ['Brak', 'do 3 500 zł', 'do 4 000 zł', 'do 5 000 zł']
  },
  {
    label: 'Operacje w wyniku choroby - wg tab. nr 8 OWU',
    values: ['Brak', 'brak', 'do 4 000 zł', 'do 5 000 zł']
  },
  {
    label: (
      <>
        <b>Koszty leczenia</b> w wyniku nieszczęśliwego wypadku - wizyty
        lekarskie, zabiegi ambulatoryjne, zlecone badania, koszty pobytu w
        szpitalu, operacje, operacje plastyczne, zakup środków opatrunkowych,
        rehabilitacja, zwrot kosztów leków do 500 zł
      </>
    ),
    values: [
      <>
        <b>do 4 000 zł</b> za wyjątkiem kosztów: rehabilitacji do 2 000 zł;
        operacji plastycznych do 8 000 zł
      </>,
      <>
        <b>do 6 500 zł</b> za wyjątkiem kosztów: rehabilitacji do 3 250 zł;
        operacji plastycznych do 13 000 zł
      </>,
      <>
        <b>do 8 000 zł</b> za wyjątkiem kosztów: rehabilitacji do 4 000 zł;
        operacji plastycznych do 16 000 zł
      </>,
      <>
        <b>do 10 000 zł</b> za wyjątkiem kosztów: rehabilitacji do 5 000 zł;
        operacji plastycznych do 20 000 zł
      </>
    ]
  },
  {
    label: 'Koszty leczenia stomatologicznego w wyniku NW',
    values: ['do 1 000 zł', 'do 1 200 zł', 'do 1 500 zł', 'do 2 000 zł']
  },
  {
    label: (
      <>
        <b>Druga Opinia Medyczna</b> - organizacja i pokrycie kosztów Drugiej
        Opinii Medycznej zagranicznej w przypadku rozpoznania Poważnej Choroby;
        świadczenie zgodnie z OWU
      </>
    ),
    values: ['brak', 'brak', 'do 5 000 zł', 'do 5 000 zł']
  },
  {
    label: 'Zwrot kosztów pogrzebu Ubezpieczonego w wyniku NW',
    values: ['brak', 'brak', 'do 3 000 zł', 'do 5 000 zł']
  },
  {
    label: 'OC praktykanta',
    values: ['10 000 zł', '10 000 zł', '20 000 zł', '50 000 zł']
  },
  {
    label: (
      <>
        Uciążliwe leczenie w wyniku NW; <b>„bólowe”</b> - brak uszczerbku na
        zdrowiu, wymagane leczenie i co najmniej dwie stacjonarne, kontrolne
        wizyty lekarskie w placówce medycznej lub czasowa niezdolność do nauki
        lub pracy przez okres nie krótszy niż 5 dni
      </>
    ),
    value: '200 zł'
  },
  {
    label:
      'Assistance EDU PLUS (indywidualne korepetycje, pomoc medyczna) - zgodnie z OWU',
    value: '5 000 zł'
  },
  {
    label: (
      <>
        Pakiet <b>KLESZCZ</b> do 100% SU - zdiagnozowanie boreliozy do 1 000
        zł; wizyta u lekarza do 150 zł; badania diagnostyczne do 150 zł;
        antybiotykoterapia do 200 zł
      </>
    ),
    value: '1 500 zł'
  },
  {
    label: (
      <>
        Opcja <b>Hejt Stop</b> - wsparcie informatyczne, psychologiczne oraz
        prawne
      </>
    ),
    value: 'TAK'
  },
  {
    label: (
      <b style={{ color: '#ff0000' }}>
        Ochrona w związku z amatorskim i wyczynowym uprawianiem sportu
      </b>
    ),
    value: <b style={{ color: '#ff0000' }}>TAK</b>
  }
];

// Kwoty świadczeń w materiale źródłowym są pogrubione, "brak" pozostaje zwykłym tekstem.
const renderValue = (value) =>
  typeof value === 'string' && value.toLowerCase() !== 'brak' ? (
    <b>{value}</b>
  ) : (
    value
  );

export const ProgramTable = () => {
  return (
    <div class="table-container">
      <table className="table table-bordered table-striped text-center">
        <tbody>
          <tr className="bg-primary">
            <td width="404">
              <p>
                <strong>ZAKRES UBEZPIECZENIA</strong>
              </p>
            </td>
            <td width="87">
              <p>
                <strong>Wariant I</strong>
              </p>
            </td>
            <td width="87">
              <p>
                <strong>Wariant II</strong>
              </p>
            </td>
            <td width="87">
              <p>
                <strong>Wariant III</strong>
              </p>
            </td>
            <td width="87">
              <p>
                <strong>Wariant IV</strong>
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <p>Kod programu</p>
            </td>
            {programCodes.map((kod) => (
              <td key={kod}>
                <p>{kod}</p>
              </td>
            ))}
          </tr>
          <tr>
            <td>
              <p>
                <strong>Opcja Podstawowa</strong>
                <br />
                Suma ubezpieczenia (SU)
              </p>
            </td>
            {sumyUbezpieczenia.map((su, index) => (
              <td key={index}>
                <p>
                  <strong>{su}</strong>
                </p>
              </td>
            ))}
          </tr>
          <tr className="bg-primary">
            <td>
              <p>
                <strong>RODZAJ ŚWIADCZENIA</strong>
              </p>
            </td>
            <td colSpan="4">
              <p>
                <strong>WYSOKOŚĆ ŚWIADCZENIA (ZŁ)</strong>
              </p>
            </td>
          </tr>
          {swiadczenia.map((row, rowIndex) => (
            <tr key={rowIndex}>
              <td style={{ textAlign: 'left' }}>
                <p>{row.label}</p>
              </td>
              {row.values ? (
                row.values.map((value, index) => (
                  <td key={index}>
                    <p>{renderValue(value)}</p>
                  </td>
                ))
              ) : (
                <td colSpan="4">
                  <p>{renderValue(row.value)}</p>
                </td>
              )}
            </tr>
          ))}
          <tr className="bg-primary">
            <td>
              <p>
                <strong>SKŁADKA ROCZNA ZA OSOBĘ:</strong>
              </p>
            </td>
            {skladkiRoczne.map((skladka, index) => (
              <td key={index}>
                <p>
                  <strong>{skladka}</strong>
                </p>
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
};
